import { INSURANCE_NAMES } from "common/consts/insurance"

const { NONE, BASIC, PLUS } = INSURANCE_NAMES

export const INSURANCES = {
  [PLUS]: {
    options: ["medical", "cancellation", "assistance", "bags", "travel", "liability"],
  },
  [BASIC]: {
    options: ["medical", "cancellation", "assistance"],
  },
  [NONE]: {
    options: [],
  },
}

// Due to AXA it's not possible to order insurance to following nationalities
// us - United states
// pr - Puerto Rico
// gu - Guam
// vi - U.S. Virgin Islands
// mp - Northern Mariana Islands
const INSURANCE_NATIONALITY_BLACKLIST = ["us", "pr", "gu", "vi", "mp"]

export function getInsurancesTypes() {
  return Object.keys(INSURANCES)
}

export function isInsuranceAllowedForNationality(nationality) {
  return !INSURANCE_NATIONALITY_BLACKLIST.includes(nationality)
}
